/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View, Platform, Animated, ScrollView } from 'react-native';
//@ts-ignore
import { observer } from 'mobx-react';
import TopNavigationBar, { TopNavigationBarPlaceholder } from '../components/TopNavigationBar';
//@ts-ignore
import {
  JDDevice,
  JDText,
  JDScrollView,
  JDNativeSystem,
  JDTouchable,
  JDImage,
  JDRouter,
  JDLogin,
  JDJumping,
  JDLoadingView,
} from '@jdreact/jdreact-core-lib';
import PropTypes from 'prop-types';
import Images from '../images';
//添加商品占位
import AddGoodsPlaceholder from '../components/AddGoodsPlaceholder';
import NoDataPlaceholder from '../components/NoDataPlaceholder';
import ContrastGoods from '../components/ContrastGoods';
//对比参数数据 tabControl
import TabControl from '../components/TabControl';
import TabContent from '../components/TabContent';
import TicketLayer from '../components/TicketLayer';
//唤起app头部
//预览商品图
import ImageViewer from '../components/ImageViewer';
//悬浮组件
import Steep from '../utils/Steep';
//store
import store from '../services/goodsContrastPageStore/store';
//埋点
import {
  logClick,
  ContrastPlus,
  ContrastMineExpo,
  ContrastCate,
  ContrastMine,
  ContrastConfirm,
} from '../mta/MtaService';
import Loading from '../components/Loading';
const { getRpx } = JDDevice;
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    // minWidth: JDDevice.getRpx(750),
    height: '100%',
  },
  contentContainerStyle: {
    backgroundColor: '#ffffff',
    height: 'auto',
  },
  wrapper: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    maxWidth: JDDevice.getRpx(1024),
  },
  goodsContainer: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    // width: JDDevice.getRpx(750),
    height: JDDevice.getRpx(334),
  },
  TabScrollList: {
    flexDirection: 'column',
    width: '100%',
  },
  myContrastPress: {
    width: getRpx(90),
    height: getRpx(90),
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: JDNativeSystem.isIPhoneX ? getRpx(100) : getRpx(35),
    right: getRpx(36),
  },
  myContrast: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: getRpx(80),
    height: getRpx(80),
    backgroundColor: '#ffffff',
    borderRadius: getRpx(40),
    elevation: 4,
    shadowOffset: {
      width: 0,
      height: getRpx(4),
    },
    shadowColor: '#000000',
    shadowOpacity: 0.08,
    shadowRadius: getRpx(12),
  },
  myContrastText: {
    width: getRpx(50),
    lineHeight: getRpx(23),
    fontSize: getRpx(22),
    textAlign: 'center',
  },
  switchCategory: {
    position: 'absolute',
    top: Steep.NAVIGATION_BAR_HEIGHT + Steep._getSteepBarHeight(),
    left: 0,
    width: getRpx(750),
    height: '100%',
  },
  cateMask: {
    width: getRpx(750),
    height: '100%',
    backgroundColor: '#000000',
  },
  checkCategory: {
    width: getRpx(24),
    height: getRpx(24),
    marginRight: getRpx(24),
  },
  categoryList: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    position: 'absolute',
    top: 0,
    left: 0,
    width: getRpx(750),
    paddingTop: getRpx(48),
    backgroundColor: 'rgba(242,242,242,1)',
    borderBottomLeftRadius: getRpx(24),
    borderBottomRightRadius: getRpx(24),
    overflow: 'hidden',
  },
  category: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: getRpx(375),
    height: getRpx(30),
    paddingLeft: getRpx(48),
    marginBottom: getRpx(48),
  },
  categoryCur: {
    fontWeight: 'bold',
  },
  categoryText: {
    fontSize: getRpx(26),
    color: ' rgb(38, 38, 38)',
    lineHeight: getRpx(38),
    height: getRpx(38),
    width: getRpx(280),
  },
  categoryPress: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: getRpx(280),
    height: getRpx(30),
  },
});
const { NavigationBar } = JDRouter;
interface IStoreProps {
  refresh?: boolean;
  store: {
    entrySku: string;
    cateId: string;
    action: string;
    isLogin: boolean;
    categoryList: {
      cateId: number;
      cateName: string;
      checked: boolean;
    }[];
    showCateList: boolean;
    showImageView: boolean;
    cateHeight: number;
    cateOpacity: number;
    contrastGoodsList: [];
    showTicketDialog: boolean;
    handleLoading: boolean;
    isReadOnly: boolean;
    slideUpSelectCategory: () => void;
    handleHideTicketDialog: () => void;
    getDataByCateId: (cateId?: string) => void;
  };
}
interface IProps extends IStoreProps {}
type PropTypes = any;

const SelfScrollView = Platform.OS === 'web' ? ScrollView : Animated.ScrollView;
class GoodsContrastPage extends React.Component<IProps, null> {
  static contextTypes = {
    router: (PropTypes as any).object,
  };
  private scrollY: Animated.Value = new Animated.Value(0);
  constructor(props: IProps) {
    super(props);
  }
  componentDidMount() {
    const {
      store: { entrySku, action },
      refresh,
    } = this.props;
    //目前有当从添加商品页 添加成功返回时才重新请求接口 路由会携带参数 refresh:true
    if (refresh) {
      store.getDataByCateId();
    }
    JDLogin.isLogin().then(
      (response: any) => {
        //@ts-ignore
        store.loginVaildate(true);
        //如果显示我的对比 我的对比曝光
        if (store.isReadOnly && Platform.OS !== 'web') {
          logClick({
            event_id: ContrastMineExpo,
            event_param: '',
            page_param: entrySku,
          });
        }
      },
      (error: any) => {
        store.loginVaildate(false);
      }
    );
  }
  goAddContrastGoodsPage = () => {
    logClick({
      event_id: ContrastPlus,
      event_param: '',
      page_param: this.props.store.entrySku,
    });
    this.context.router.toAddGoodsContrast({ cateId: this.props.store.cateId });
  };
  login = () => {
    const {
      store: { isLogin, cateId, entrySku },
    } = this.props;
    logClick({
      event_id: ContrastMine,
      event_param: '',
      page_param: entrySku,
    });
    if (isLogin) {
      JDJumping.jumpToOpenapp(
        `openapp.jdmobile://virtual?params={"category":"jump","des":"jdreactcommon","modulename":"JDReactGoodsContrast","appname":"JDReactGoodsContrast","ishidden":true,"param":{"cateId":"${cateId}","action":"3","client":"app"},"h5params":{"app":"1"}}`
      );
    } else {
      JDLogin.doLogin();
    }
  };
  slideUpSelectCategory = () => {
    this.props.store.slideUpSelectCategory();
  };
  handleHideTicketDialog = () => {
    logClick({
      event_id: ContrastConfirm,
      event_param: '',
      page_param: this.props.store.entrySku,
    });
    this.props.store.handleHideTicketDialog();
  };
  render() {
    const {
      store: {
        showTicketDialog,
        contrastGoodsList,
        categoryList,
        showCateList,
        showImageView,
        cateHeight,
        cateOpacity,
        entrySku,
        isLogin,
        handleLoading,
        isReadOnly,
      },
    } = this.props;
    if (Platform == 'web' && contrastGoodsList.length == 0) {
      return <NoDataPlaceholder />;
    }
    return (
      <>
        <View style={styles.container}>
          {Platform.OS !== 'web' ? (
            <>
              <TopNavigationBar isNormal={false} />
              <TopNavigationBarPlaceholder />
            </>
          ) : null}
          <SelfScrollView
            bounces={false}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={styles.contentContainerStyle}
            stickyHeaderIndices={[Platform.OS === 'web' ? 0 : 1]}
          >
            {Platform.OS === 'web' ? (
              <View
                style={{
                  position: 'relative',
                  zIndex: 10000,
                  elevation: 5,
                  width: getRpx(750),
                  height: getRpx(90),
                }}
              >
                <TabControl />
              </View>
            ) : null}
            <JDScrollView
              horizontal
              showsHorizontalScrollIndicator={false}
              bounces={false}
              contentContainerStyle={styles.contentContainerStyle}
            >
              <View style={styles.wrapper}>
                {handleLoading ? (
                  <View
                    style={{
                      width: getRpx(750),
                      height: '100%',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'transparent',
                      position: 'absolute',
                      top: getRpx(-150),
                      left: 0,
                      zIndex: 100,
                    }}
                  >
                    <JDLoadingView />
                  </View>
                ) : null}
                {/* {Platform.OS == 'web' ? <JDText>im web</JDText> : <JDText>im native</JDText>} */}
                <View style={styles.goodsContainer}>
                  {/* 无商品时 */}
                  {/* <ContrastGoods /> */}
                  {/* <AddGoodsPlaceholder /> */}
                  {contrastGoodsList && contrastGoodsList.length > 0 ? (
                    <ContrastGoods isReadOnly={isReadOnly} />
                  ) : (
                    <JDTouchable onPress={this.goAddContrastGoodsPage}>
                      <AddGoodsPlaceholder golbalSku={entrySku} />
                    </JDTouchable>
                  )}
                </View>
                <View style={styles.TabScrollList}>
                  {contrastGoodsList && contrastGoodsList.length > 0 ? (
                    <TabContent isReadOnly={isReadOnly} />
                  ) : (
                    <NoDataPlaceholder />
                  )}
                </View>
              </View>
            </JDScrollView>
            {Platform.OS !== 'web' ? (
              <View
                style={{
                  position: 'absolute',
                  top: getRpx(334),
                  left: 0,
                  width: getRpx(750),
                  height: getRpx(90),
                }}
              >
                <TabControl />
              </View>
            ) : null}
          </SelfScrollView>
          {/* 切品类弹层 */}
          {showCateList ? (
            <View style={styles.switchCategory}>
              <JDTouchable onPress={this.slideUpSelectCategory}>
                <Animated.View
                  style={[
                    styles.cateMask,
                    {
                      opacity: cateOpacity,
                    },
                  ]}
                ></Animated.View>
              </JDTouchable>
              <Animated.View
                style={[
                  styles.categoryList,
                  {
                    maxHeight: cateHeight,
                  },
                ]}
              >
                {categoryList.map((category, index) => {
                  return (
                    <JDTouchable
                      style={styles.category}
                      key={category.cateId}
                      onPress={() => {
                        logClick({
                          event_id: ContrastCate,
                          event_param: '',
                          page_param: entrySku,
                        });
                        store.handleSwitchCategory(category);
                      }}
                    >
                      <View style={styles.categoryPress}>
                        {category.checked ? (
                          <JDImage source={Images.common.checkCategory} style={styles.checkCategory}></JDImage>
                        ) : null}
                        <JDText
                          style={category.checked ? [styles.categoryText, styles.categoryCur] : styles.categoryText}
                          type={'regular'}
                          numberOfLines={1}
                        >
                          {category.cateName}
                        </JDText>
                      </View>
                    </JDTouchable>
                  );
                })}
              </Animated.View>
            </View>
          ) : null}
        </View>
        {/* 优惠券弹层 */}
        {/* <JDPopupWindow
          show={showTicketDialog}
          onHide={this.handleHideTicketDialog}
          speed={0.8}
          height={getRpx(1054) - JDNativeSystem.isIPhoneX ? getRpx(78) : getRpx(100)}
        >
          <View style={{ height: getRpx(1266), width: '100%' }}>
            <TicketLayer />
          </View>
        </JDPopupWindow> */}
        {showTicketDialog ? <TicketLayer /> : null}
        {/* 我的对比入口 */}
        {isReadOnly && Platform.OS !== 'web' ? (
          <JDTouchable onPress={this.login} style={styles.myContrastPress}>
            <View style={styles.myContrast}>
              <JDText style={styles.myContrastText}>我的对比</JDText>
            </View>
          </JDTouchable>
        ) : null}
        {/*预览商品图*/}
        {showImageView ? <ImageViewer /> : null}
      </>
    );
  }
}

const GoodsContrastPageOberver = observer(GoodsContrastPage);
const GoodsContrastPageOberverWapper = (props: IProps) => <GoodsContrastPageOberver {...props} store={store} />;
export default GoodsContrastPageOberverWapper;
